import { useState, useEffect } from 'react';
import "./FormResponsesDeleteModal.css";
import Modal from "../shared/Modal";

type FormResponsesDeleteModalProps = {
    isOpen: boolean;
    count: number;
    onClose: () => void;
    onSubmit: () => void;
}

export const FormResponsesDeleteModal = ({isOpen, count, onClose, onSubmit}: FormResponsesDeleteModalProps) => {

    return (
        <Modal
            isOpen={isOpen}
            style={null}
            onClose={onClose}
            canClose={true}
            allowClickout={true}
        >
            <div 
                className="form-responses-delete-container"
                data-testid="form-responses-delete-modal"
            >
                <div className="modal-title">
                    Delete {count} response{count === 1 ? "" : "s"}?
                </div>
                
                <p>Are you sure you want to delete {count===1 ? "this response" : "these responses"}?</p>
                There is no way to recovered deleted responses.
                <div className="modal-buttons">
                    <button 
                        className="button-cancel"
                        onClick={onClose}
                    > 
                        Cancel
                    </button>

                    <button 
                        className="button-save"
                        onClick={onSubmit}
                        data-testid="form-responses-delete-modal-submit"
                    > 
                        Delete
                    </button>
                </div>
               
            </div>
      </Modal>
    )
}